import { useEffect } from "react"

import { Avatar, Flex, Typography } from "antd"
import cls from "classname"
import { connect } from "react-redux"
import { NavLink, useLocation, useNavigate } from "react-router-dom"

import ButtonComponent from "../../Components/Button"
import Icon from "../../Icon"
import { useQuery } from "../../Utils/utils"
import { getBusinessAccount } from "../User/redux/user.thunks"

import "./styles.less"

const { Text } = Typography

const navListUsersViewPages = [
  { path: "/admin/dashboard", label: "Dashboard" },
  { path: "/admin/alerts", label: "Alerts" },
  { path: "/admin/integrations", label: "Integrations" }
]

const LayoutUserPageForAdmin = ({ isAdmin, businessAccount, children, ...props }) => {
  const navigate = useNavigate()
  const { search, pathname } = useLocation()
  let query = useQuery(search)
  let business_account_id = query.get("business_account_id")

  useEffect(() => {
    if (isAdmin && businessAccount?.id !== business_account_id)
      props.getBusinessAccount(business_account_id)
  }, [businessAccount, business_account_id])

  return (
    <>
      <Flex justify="space-between" align={"center"} className="admin-sub-header">
        <Flex gap={4} align="center">
          <Avatar
            className="user_avatar"
            size={24}
            style={{
              backgroundColor: businessAccount?.photo ? "transparent" : "#225AEA",
              borderRadius: "12px",
              border: "none",
              fontSize: 14,
              marginRight: 4
            }}
            src={businessAccount?.photo || null}
          >
            {!businessAccount?.photo ? businessAccount?.name?.[0] : null}
          </Avatar>
          <Text strong style={{ color: "#27272A" }}>
            {businessAccount?.name}
          </Text>
          <Text type="secondary">user view</Text>
        </Flex>

        <Flex gap={24} align="center">
          {navListUsersViewPages.map(({ path, label }) => (
            <NavLink
              key={path}
              to={`${path}?business_account_id=${business_account_id}`}
              className={cls("navigate-link", { active: pathname.includes(path) })}
            >
              <Text type="secondary" strong>
                {label}
              </Text>
            </NavLink>
          ))}
        </Flex>

        <ButtonComponent
          type={"link"}
          //onClick={() => navigate(-1)}
          onClick={() => navigate("/alerts")}
          icon={<Icon type={"step_back"} />}
        >
          Back to admin panel
        </ButtonComponent>
      </Flex>
      {children}
    </>
  )
}

const mapStateToProps = (state) => ({
  isAdmin: state.auth.isAdmin,
  businessAccount: state.user.businessAccount
})

const mapDispatchToProps = (dispatch) => ({
  getBusinessAccount: (businessAccountId) => dispatch(getBusinessAccount(businessAccountId))
})

export default connect(mapStateToProps, mapDispatchToProps)(LayoutUserPageForAdmin)
